export const config = Object.freeze({
  ...__APP_SETTINGS__,
  version: __APP_VERSION__,
  // Keep release timestamps out of every shared JS chunk's content hash.
  build: document.querySelector<HTMLMetaElement>('meta[name="yestv-build"]')?.content || `${__APP_SETTINGS__.environment}-development`,
});
export const storageKey = (key: string) =>
  `yestv:${config.environment}:v1:${key}`;
